import React from "react";

import "./navbarMobile.css";

import Logo from "../../assets/img/logo-og.png";
import Logo2 from "../../assets/img/slk_logo.png";
import Logo3 from "../../assets/img/gopu-nandilath-G-mart-white.png";

// import FifaBanner from "../../assets/img/fifa-pred-banner.png";
import FifaBanner from "../../assets/img/top-main-banner.png";
import DropIcon from "../../assets/icon/dropdown.svg";
import RightIcon from "../../assets/icon/R-arrow.svg";
import { useState } from "react";
import RegisterView from "../../views/register/RegisterView";
import Logout from "../../components/logout/Logout";
import MobileMatchStat from "../../components/mobileMatchStat/MobileMatchStat";

const NavbarMobile = () => {
  return (
    <div className="navbarMobile">
      <img src={FifaBanner} alt="" />
    </div>
  );
};

export default NavbarMobile;
